module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-244.4abe053e.svg";